export default __webpack_public_path__ + "static/media/collapseMenuIcon.2682acd5.svg";